'use-client';

import React from 'react';
import { classes, st } from './HamburgerOpenButton.component.st.css';
import { classes as stylableButtonClasses } from '../../../../../StylableButton/viewer/StylableButton.component.st.css';
import type {
  IStylableButtonImperativeActions,
  IStylableButtonProps,
} from '../../../../../StylableButton/StylableButton.types';
import HamburgerOpenButtonCommon from '../../HamburgerOpenButton';
import StylableButton from '../../../../../StylableButton/viewer/skinComps/Default/Default.skin';

const DefaultSkin: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  IStylableButtonProps
> = props => {
  const extendedProps = {
    ...props,
    classes: {
      ...classes,
      hamburgerOpenButtonRoot: st(classes.root),
      stylableButtonRoot: st(stylableButtonClasses.root),
    },
    StylableButton,
  };
  return <HamburgerOpenButtonCommon {...extendedProps} />;
};

export default React.forwardRef(DefaultSkin);
